'use strict';

export function dataToContact(data) {
    return {
        title: data.title,
        first_name: data.first_name,
        last_name: data.last_name,
        position: data.position,
        birth_date: data.birth_date || null,
        info: data.info.filter((info) => info.value).map((i) => {
            const o = Object.assign({}, i);

            if (i.type === 'address') {
                o.value = JSON.stringify(i.value);
            }

            return o;
        })
    };
}

/**
 *  Format a contact object to an editable contact
 *
 * @param contact
 * @returns {{id, first_name: *|string, last_name: *|string, birth_date: null, title: string|*,
 * info}}
 */
export function contactToData(contact) {
    contact.info = contact.info || [];
    contact.title = contact.title || 'monsieur';
    const data = {
        id: contact.id,
        first_name: contact.first_name,
        last_name: contact.last_name,
        birth_date: contact.birth_date,
        title: contact.title,
        position: contact.position,
        info: contact.info.map((i) => {
            const o = Object.assign({}, i);

            if (i.type === 'address') {
                o.value = JSON.parse(i.value);
            }

            return o;
        })
    };

    return data;
}

/**
 * Create a default client object with empty value
 * @param title
 * @returns {{
 *      title: *|string,
 *      last_name: string,
 *      first_name: string,
 *      position: undefined,
 *      birth_date: undefined,
 *      info: Array
 * }}
 */
export function makeDefaultData(title) {
    return {
        title: title || 'mademoiselle',
        last_name: '',
        first_name: '',
        position: undefined,
        birth_date: undefined,
        info: []
    };
}

/**
 * Generate default data structure for an info item
 */
export function makeDefaultInfo(type, label = 'Domicile') {
    return {
        type,
        label,
        value: ''
    };
}

/**
* Merge 2 contacts together
 *
 * @param contact1 Element dropped
 * @param contact2 dropped to this contact
 */
export function mergeContacts(c1, c2, newIndex = 1) {
    const emptyContact = {
        infos: [],
        exchanges: [],
        names: []
    };
    const contact1 = Object.assign({}, emptyContact, c1);
    const contact2 = Object.assign({}, emptyContact, c2);
    let names = [];
    if (!contact2.names.length) {
        names = [
            {
                active: true,
                ctIndex: contact2.ctIndex,
                title: contact2.title,
                first_name: contact2.first_name,
                last_name: contact2.last_name
            }
        ];
    } else {
        names = contact2.names;
    }
    names = names.concat(
        {
            active: true,
            ctIndex: contact1.ctIndex,
            title: contact1.title,
            first_name: contact1.first_name,
            last_name: contact1.last_name
        }
    );
    names = names.map((name) => {
        name.ctIndex = contact2.ctIndex || newIndex;
        return name;
    });
    const c1Infos = contact1.infos.map((info) => {
        return Object.assign({}, info, {ctIndex: contact2.ctIndex || newIndex});
    });
    const c2Infos = contact2.infos;
    const cInfos = c2Infos.concat(c1Infos);
    const uniqInfo = removeDuplicates(cInfos, 'value');
    contact2.infos = uniqInfo;
    contact2.names = names.filter(name => (name.first_name !== undefined &&
        name.last_name !== undefined)
    );
    if (contact2.names.length === 1) {
        contact2.first_name = contact2.names[0].first_name;
        contact2.last_name = contact2.names[0].last_name;
        contact2.names = [];
    }
    contact2.exchanges = contact2.exchanges.concat(contact1.exchanges);
    const newContact = Object.assign({}, contact1, contact2);
    if (newIndex) {
        newContact.ctIndex = newIndex;
    }
    return newContact;
}

export function removeDuplicates(array, prop) {
    return array.filter((obj, pos, arr) => {
        return arr.map(mapObj => mapObj[prop]).indexOf(obj[prop]) === pos;
    });
}



// WEBPACK FOOTER //
// ./src/components/clients/utils.js